import { createContext, useState, useEffect } from 'react';
import axios from '../axios-config';

export const OrganizationJobsContext = createContext<any>(null);

export function OrganizationJobsContextProvider({ children }: { children: React.ReactNode }) {
  const [organizationJobs, setOrganizationJobs] = useState([]);
  
  const [organizationAssignments, setOrganizationAssignments] = useState([]);
  const fetchOrganizationJobAssignments = async () => {
    try {
      const { data } = await axios.get('/api/OrganizationJobs/assignments');
      setOrganizationAssignments(data);
    } catch (error) {
      console.error("Error fetching organization assignments:", error);
    }
  };

  useEffect(() => {
    fetchOrganizationJobs();
    fetchOrganizationJobAssignments();
  }, []);

  const fetchOrganizationJobs = async () => {
    const { data } = await axios.get('/api/OrganizationJobs');
    setOrganizationJobs(data);
    return data;
  };

  const createOrganizationJob = async (payload: any) => {
    await axios.post('/api/OrganizationJobs', payload);
    await fetchOrganizationJobs();
  };

  const updateOrganizationJob = async (id: any, payload: any) => {
    await axios.put(`/api/OrganizationJobs/${id}`, payload);
    await fetchOrganizationJobs();
  };

  const deleteOrganizationJob = async (id: any) => {
    await axios.delete(`/api/OrganizationJobs/${id}`);
    await fetchOrganizationJobs();
  };

  return (
    <OrganizationJobsContext.Provider value={{
      fetchOrganizationJobs,
      organizationJobs,
      organizationAssignments,
      setOrganizationAssignments,
      fetchOrganizationJobAssignments,
      createOrganizationJob,
      updateOrganizationJob,
      deleteOrganizationJob
    }}>
      {children}
    </OrganizationJobsContext.Provider>
  );
};
